import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';

export const syncTypesCommand = (
  services: CommandServices,
  cliVersion: string
) =>
  createCommand('sync-types').action(async (_, command) => {
    const { runCommand } = await import('./run-command.js');
    const { syncTypes } = await import('../sync-types/index.js');

    await runCommand(command, services, cliVersion, (model) =>
      syncTypes(model, services)
    );
  });
